
/**
 * It creates a localStorage object with the key provided.
 * @param key - The key to use for the localStorage item.
 */
export const createLocalStorage = function (key) {
    if (!localStorage.getItem(key)) {
        localStorage.setItem(key, JSON.stringify({}))
    }

    let appStorage = JSON.parse(localStorage.getItem(key));

    function save() {
        localStorage.setItem(key, JSON.stringify(appStorage));
    }

    /**
     * It takes two arguments, a key and a value, and then it sets the key to the value in the
     * appStorage object
     * @param key - The key to store the value under.
     * @param value - The value to be stored.
     */
    function set(key, value) {
        appStorage[key] = value;
        save();
    }

    function get(key) {
        return appStorage[key];
    }
    /**
     * It returns the value of the key in the appStorage object
     * @param key - The key to store the value under.
     * @returns The value of the key in the appStorage object.
     */

    /* Deleting the key from the appStorage object. */
    function remove() {
        delete appStorage[key]
        save();
    }

    return { set, get, remove }
}


/**
 * It removes the value of the key from the localStorage.
 * @param key - The key of the item you want to remove from localStorage.
 */
export const removeLocalStorage = function (key) {
    localStorage.removeItem(key);
}